import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    titleProgramAttendance: ""
}

export const scannerSlice = createSlice({
  name: 'scannerBlended',
  initialState,
  reducers: {
    setTitleProgramAttendance: (state, action) => {
      state.titleProgramAttendance = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setTitleProgramAttendance } = scannerSlice.actions

export default scannerSlice.reducer